import { Component } from '@angular/core';
import { membersuiteRefundLineItemEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Refund Line Items') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiterefundlineitem-form',
    templateUrl: './membersuiterefundlineitem.form.component.html'
})
export class membersuiteRefundLineItemFormComponent extends BaseFormComponent {
    public record!: membersuiteRefundLineItemEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

